import * as React from 'react';

import UserInfo from '../../interfaces/UserInfo';

interface Props {
  tableHeadItem: string;
  firstUserInfoItem: UserInfo;
  fetchRefreshAuth: (firstLoad: boolean) => void;
  fetchFindUserAuthIdAction: (id: string) => void;
}

function RelatedUsers (props: Props) {

  const renderNewPersonalInfoById = (e) => {
    fetchFindUserAuthIdAction(e.target.value);
    fetchRefreshAuth(false);
  };

  const {
    fetchFindUserAuthIdAction,
    fetchRefreshAuth,
    tableHeadItem,
    firstUserInfoItem,
  } = props;

  return (
    <div className='d-flex border-row'>
      <div className='personal-title bold'>
        {tableHeadItem[0].toUpperCase() + tableHeadItem.slice(1).split('_').join(' ')}
      </div>
      <div className='personal-text'>
        {
          firstUserInfoItem[tableHeadItem].map((relUser, key) => {
            return (
              <span
                className='related-wrap'
                key={key}>
                <input
                  onClick={renderNewPersonalInfoById}
                  className='related_button'
                  type='button'
                  value={relUser} />
                <span>{','}</span>
              </span>
            );
          })
        }
      </div>
    </div>
  );
}

export default React.memo(RelatedUsers);
